import { SearchBox } from "@fluentui/react";
import { useState } from "react";

export default function ProductSearchView() {
    const [text, setText] = useState("");

    return <>
        <SearchBox
            autoFocus={false}
            value={text}
            placeholder="Search"
            onChange={(_, newValue) => setText(newValue || "")}
            onSearch={(value: string) => {
                window.open("/products?searchText=" + value, "_self");
            }}
            onClear={() => {
                window.open("/products?searchText=", "_self");
            }}
            className="searchbox"
            styles={{ root: { width: "100%" } }}
        />
    </>;
}